import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';

@Component({
  selector: 'era-key-value-edit',
  templateUrl: './key-value-edit.component.html',
  styleUrls: ['./key-value-edit.component.scss'],
  imports: [ReactiveFormsModule, FaIconComponent],
})
export class KeyValueEditorComponent implements OnChanges {
  @Input() allowEditing: boolean;
  @Input() keyValueSet: Record<string, string> = {};
  @Output() keyValueSetChanged = new EventEmitter<Record<string, string>>();

  form = this.fb.group({
    pairs: this.fb.array<FormGroup>([]),
  });
  public editing = false;
  constructor(private fb: FormBuilder) {}

  get formArray(): FormArray {
    return this.form.get('pairs') as FormArray;
  }

  get controls() {
    return this.formArray.controls as FormGroup[];
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.keyValueSet) {
      this.formArray.clear();
      const value: Record<string, string> = changes.keyValueSet.currentValue ?? {};
      const groups = Object.entries(value).map(([key, val]) => this.buildGroup(key, val));
      groups.forEach((group) => {
        this.formArray.push(group);
      });
    }

    if (!this.editing) {
      this.form.disable();
    }
  }

  private buildGroup(key = '', value = ''): FormGroup {
    return this.fb.group({
      key: [key, Validators.required],
      value: [value],
    });
  }

  addPair() {
    this.formArray.push(this.buildGroup());
  }

  removePair(index: number) {
    this.formArray.removeAt(index);
  }

  submit() {
    this.toggleEditing();
    this.emitChanges();
  }

  private emitChanges() {
    const dict: Record<string, string> = {};
    for (const group of this.formArray.controls) {
      const { key, value } = group.value;
      if (key) dict[key] = value;
    }
    this.keyValueSetChanged.emit(dict);
  }

  toggleEditing(): void {
    this.editing = !this.editing;
    if (!this.editing) {
      this.form.disable();
    } else {
      this.form.enable();
    }
  }
}
